

// Generated class Module_ManagedObject

class Module_ManagedObject extends MIOManagedObject
{
}
